import { FC, useState } from "react";
import {
  Box,
  IconButton,
  makeStyles,
  Tooltip,
  Typography,
} from "@material-ui/core";
import { Check as CheckIcon, FileCopy as CopyIcon } from "@material-ui/icons";

const useStyles = makeStyles(theme => ({
  row: {
    marginBottom: theme.spacing(1),
  },
  label: {
    color: theme.palette.text.secondary,
    textTransform: "uppercase",
  },
  iconButton: {
    padding: theme.spacing(1),
    marginLeft: theme.spacing(1),
  },
  icon: {
    fontSize: 14,
  },
  successIcon: {
    fontSize: 14,
    color: theme.palette.success.main,
  },
}));

interface CopyRowProps {
  label: string;
  value: string;
}

const CopyRow: FC<CopyRowProps> = ({ label, value }) => {
  const classes = useStyles();
  const [copied, setCopied] = useState(false);

  const onCopy = async () => {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      setTimeout(() => setCopied(false), 5000);
    } catch {}
  };

  return (
    <Box className={classes.row}>
      <Typography variant="caption" className={classes.label}>
        {label}
      </Typography>
      <Tooltip title={copied ? "Copied!" : "Copy"}>
        <IconButton
          size="small"
          onClick={onCopy}
          className={classes.iconButton}
        >
          {copied ? (
            <CheckIcon className={classes.successIcon} />
          ) : (
            <CopyIcon className={classes.icon} />
          )}
        </IconButton>
      </Tooltip>
      <Typography variant="body2">{value}</Typography>
    </Box>
  );
};

export default CopyRow;
